import type { ConnectablePlatform } from '@shared/all/crosspost';
import {
  Facebook,
  Instagram,
  Linkedin,
  type LucideIcon,
  Music,
  Twitter,
  Youtube
} from 'lucide-react';

export type PlatformBrand = { icon: LucideIcon; color: string; bg: string };

// One tile per network, shared by the settings cards and the composer picker.
export const PLATFORM_BRAND: Record<ConnectablePlatform, PlatformBrand> = {
  TIKTOK: { icon: Music, color: 'text-[#ff0050]', bg: 'bg-[#ff0050]/10' },
  YOUTUBE: { icon: Youtube, color: 'text-[#FF0000]', bg: 'bg-[#FF0000]/10' },
  INSTAGRAM: {
    icon: Instagram,
    color: 'text-[#E4405F]',
    bg: 'bg-[#E4405F]/10'
  },
  FACEBOOK: { icon: Facebook, color: 'text-[#1877F2]', bg: 'bg-[#1877F2]/10' },
  TWITTER: { icon: Twitter, color: 'text-[#1DA1F2]', bg: 'bg-[#1DA1F2]/10' },
  LINKEDIN: { icon: Linkedin, color: 'text-[#0A66C2]', bg: 'bg-[#0A66C2]/10' }
};
